import { createHttpInstance } from '~/common/utils/http';

const httpInstance = createHttpInstance('ticket', { path: '/ticket' });

export default httpInstance;
